import { styled } from '@mui/material';
import FormControl from '@mui/material/Box';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import './style.scss';
import { Link, useNavigate } from 'react-router-dom';

Languages.propTypes = {};

const SelectCustom = styled(Select)({
    '& > div': {
        padding: '8px 25px',
        color: '#000000',
        fontSize: '0.75rem',
    },
    '& svg': {
        color: '#000000',
    },
    '& fieldset': {
        border: 'none',
    },
});

function Languages(props) {
    const { i18n } = useTranslation();
    const [language, setLanguage] = useState('vi');
    const navigate = useNavigate();

    const handleChange = (e) => {
        if (e.target.value === 'ja') {
            window.location.href =
                'https://www.saisoncard.co.jp/creditcard/extended/3168819/?fbclid=IwAR3gt_RsvkfWzxrloVMI5IB17NyQgKJgzeITxEgFu6lx0E5fa5i0ymdIGUc';
            return null;
        }
        setLanguage(e.target.value);
        i18n.changeLanguage(e.target.value);

        // localStorage.setItem('languages', e.target.value);
    };
    return (
        <FormControl>
            <SelectCustom
                value={language}
                onChange={handleChange}
                displayEmpty
                inputProps={{
                    'aria-label': 'Without label',
                }}
                sx={{
                    color: '#323232',
                    '.MuiList-root': {
                        listStyle: 'none',
                    },
                }}
            >
                <MenuItem
                    sx={{
                        '&:before': {
                            content: '"."',
                        },
                    }}
                    value={'vi'}
                >
                    Tiếng Việt
                </MenuItem>
                <MenuItem
                    sx={{
                        '&:before': {
                            content: '"."',
                        },
                    }}
                    value={'en'}
                >
                    English
                </MenuItem>
                <MenuItem
                    sx={{
                        '&:before': {
                            content: '"."',
                        },
                    }}
                    value={'id'}
                >
                    Bahasa Indonesia
                </MenuItem>
                {/* <MenuItem
                    sx={{
                        '&:before': {
                            content: '"."',
                        },
                    }}
                    value={'bn'}
                >
                    Bengali
                </MenuItem> */}
                {/* <MenuItem
                    sx={{
                        '&:before': {
                            content: '"."',
                        },
                    }}
                    value={'ko'}
                >
                    한국어
                </MenuItem> */}
                <MenuItem
                    sx={{
                        '&:before': {
                            content: '"."',
                        },
                    }}
                    value={'km'}
                >
                    Khmer ខ្មែរ
                </MenuItem>
                <MenuItem
                    sx={{
                        '&:before': {
                            content: '"."',
                        },
                    }}
                    value={'fil'}
                >
                    Filipino
                </MenuItem>
                <MenuItem
                    sx={{
                        '&:before': {
                            content: '"."',
                        },
                    }}
                    value={'pt'}
                >
                    Português
                </MenuItem>
                <MenuItem
                    sx={{
                        '&:before': {
                            content: '"."',
                        },
                    }}
                    value={'zh'}
                >
                    中文
                </MenuItem>
                <MenuItem
                    sx={{
                        '&:before': {
                            content: '"."',
                        },
                    }}
                    value={'ja'}
                >
                    日本語
                </MenuItem>
            </SelectCustom>
        </FormControl>
    );
}

export default Languages;
